/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @param {Object} props            Properties passed to the function.
 * @param {Object} props.attributes Available block attributes.
 *
 * @return {Element} Element to render.
 */
export default function save( { attributes } ) {
	const { headingStyle, headingTag, headingText, accentColor, borderColor } = attributes;

	// If there is no fallbackCurrentYear, which could happen if the block
	// is loaded from a template/pattern, return null. In this case, block
	// rendering will be handled by the render.php file.
	let displayDate;

	if ( ! headingText ) {
		displayDate = 'This is a heading title'
	} else {
		displayDate = headingText;
	}

	const HeadingTagL = `h${headingTag}`;

	return 	<div className={`pchead-e-block pchead-e-${headingStyle} heading${headingTag}-${headingStyle}`}><HeadingTagL { ...useBlockProps.save() }>{ displayDate }</HeadingTagL></div>

}
